var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuizDragWords(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#8F8F8F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    d: "M.696 5.788h5.718M19.096 5.788h4.507M16.15 5.788h2.249"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    d: "M14.959 7.319H7.596a.25.25 0 0 1-.25-.25V4.506a.25.25 0 0 1 .25-.25h7.363a.25.25 0 0 1 .25.25v2.563a.25.25 0 0 1-.25.25z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#6BB9D6",
    d: "M16.153 12.324H8.79a.25.25 0 0 1-.25-.25V9.511a.25.25 0 0 1 .25-.25h7.363a.25.25 0 0 1 .25.25v2.563a.25.25 0 0 1-.25.25zM6.186 23.393H.928a.25.25 0 0 1-.25-.25V20.58a.25.25 0 0 1 .25-.25h5.259a.25.25 0 0 1 .25.25v2.563a.2516.2516 0 0 1-.251.25zM18.416 23.393H7.456a.25.25 0 0 1-.25-.25V20.58a.25.25 0 0 1 .25-.25h10.959a.25.25 0 0 1 .25.25v2.563c.001.138-.111.25-.249.25zM23.07 23.393h-3.362a.25.25 0 0 1-.25-.25V20.58a.25.25 0 0 1 .25-.25h3.362a.25.25 0 0 1 .25.25v2.563a.25.25 0 0 1-.25.25zM8.29 19.725H.928a.25.25 0 0 1-.25-.25v-2.563a.25.25 0 0 1 .25-.25H8.29a.25.25 0 0 1 .25.25v2.563c0 .138-.111.25-.25.25zM23.072 19.725H18.12a.25.25 0 0 1-.25-.25v-2.563a.25.25 0 0 1 .25-.25h4.953a.25.25 0 0 1 .25.25v2.563a.251.251 0 0 1-.251.25z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "#000",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    d: "M17.111 14.88h-1.65l1.146 2.73-.916.384-1.145-2.73-1.238 1.226v-5.398z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuizDragWords);
export default __webpack_public_path__ + "static/media/quiz_dragWords.5d1d0bfe7ea1aa7950657594a9cc6782.svg";
export { ForwardRef as ReactComponent };